import { render, staticRenderFns } from "./ImageMode.vue?vue&type=template&id=0de04688"
import script from "./ImageMode.vue?vue&type=script&lang=js"
export * from "./ImageMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0de04688')) {
      api.createRecord('0de04688', component.options)
    } else {
      api.reload('0de04688', component.options)
    }
    module.hot.accept("./ImageMode.vue?vue&type=template&id=0de04688", function () {
      api.rerender('0de04688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/formControls/ImageMode.vue"
export default component.exports